import React from "react";
import { useNavigate } from "react-router-dom";
import { FaTimesCircle } from "react-icons/fa"; // وارد کردن آیکون ضربدر
import "./orderFailurePage.css";

const OrderFailurePage = () => {
  const navigate = useNavigate();

  return (
    <div className="order-failure-container">
      <FaTimesCircle className="failure-icon" />
      <h1 className="order-failure-message">
        سفارش شما ثبت نشد، در صورت مشکل با پشتیبانی در ارتباط باشید.
      </h1>
      <button className="return-home-button" onClick={() => navigate("/")}>
        برگشت به خانه
      </button>
    </div>
  );
};

export default OrderFailurePage;
